/**
 * Role detail APIs sometimes return `tiles` / `policy` as a string[], and
 * sometimes as a plain object (or `{ dashboard_tiles: [...] }`). Normalize to
 * a string[] so callers can safely `.map` / build a Set.
 */
export function asStringIdArray(value: unknown): string[] {
  if (value == null) return []
  if (Array.isArray(value)) return value.map(String)

  if (typeof value === 'object') {
    const record = value as Record<string, unknown>
    if (Array.isArray(record.dashboard_tiles)) {
      return record.dashboard_tiles.map(String)
    }

    const values = Object.values(record)
    if (
      values.length > 0 &&
      values.every(
        (entry) =>
          entry == null ||
          typeof entry === 'string' ||
          typeof entry === 'number' ||
          typeof entry === 'boolean',
      )
    ) {
      return values
        .filter((entry) => entry != null && entry !== false && entry !== 0 && entry !== '0')
        .map(String)
    }

    return Object.keys(record).map(String)
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const trimmed = String(value).trim()
    return trimmed ? [trimmed] : []
  }

  return []
}
